import { useState, useRef } from "react";
import { toast } from "react-toastify";
import ReCAPTCHA from "react-google-recaptcha";

const SimpleCareerForm = () => {
const recaptcha = useRef();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    file: null,
    position: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const positions = [
    "—Please choose an option—",
    "Frontend Developer",
    "Backend Developer",
    "SEO",
    "Social Media Marketing",
    "UI/UX",
  ];

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "file") {
      setFormData({ ...formData, file: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const token = await recaptcha.current.executeAsync();
    recaptcha.current.reset();

    const { name, email, phone, position, message, file } = formData;

    if (!name || !email || !phone || !position || !message || !file || position === positions[0]) {
      toast.error("Please fill all the fields.");
      setLoading(false);
      return;
    }

    const formPayload = new FormData();
    formPayload.append("name", name);
    formPayload.append("email", email);
    formPayload.append("phone", phone);
    formPayload.append("position", position);
    formPayload.append("message", message);
    formPayload.append("file", file);
    formPayload.append("g-recaptcha-response", token);
    formPayload.append("_template", "table");
    formPayload.append("_captcha", "false");
    formPayload.append("_next", "https://mean3.com/thank-you");

    try {
      const res = await fetch("https://formsubmit.co/info@mean3.com", {
        method: "POST",
        body: formPayload,
      });

      if (res.ok) {
        toast.success("Form submitted successfully!");
        setFormData({
          name: "",
          email: "",
          phone: "",
          position: positions[0],
          message: "",
          file: null,
        });
      } else {
        toast.error("Submission failed. Try again.");
      }
    } catch (error) {
      toast.error("Error submitting the form.");
    }

    setLoading(false);
  };

  return (
    <form onSubmit={handleSubmit} className="max-w-3xl mx-auto p-2 space-y-4" encType="multipart/form-data">
      <input type="text" name="name" placeholder="Your Name" value={formData.name} onChange={handleChange} className="w-full border p-2 rounded" required />
      <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} className="w-full border p-2 rounded" required />
      <input type="tel" name="phone" placeholder="Phone Number" value={formData.phone} onChange={handleChange} className="w-full border p-2 rounded" required />
      <input type="file" name="file" accept=".pdf,.doc,.docx" onChange={handleChange} className="w-full border p-2 rounded" required />

      <select name="position" value={formData.position} onChange={handleChange} className="w-full border p-2 rounded" required>
        {positions.map((pos) => (
          <option key={pos} value={pos}>
            {pos}
          </option>
        ))}
      </select>

      <textarea name="message" placeholder="Tell us about yourself" value={formData.message} onChange={handleChange} rows="4" className="w-full border p-2 rounded" required></textarea>


      <ReCAPTCHA ref={recaptcha} sitekey={process.env.REACT_APP_SITE_KEY} size="invisible" />

      <button type="submit" disabled={loading} className="bg-[#cd2122] w-[100%] font-bold text-white py-2 px-6 rounded-sm">
        {loading ? "Submitting..." : "Submit"}
      </button>
    </form>
  );
};

export default SimpleCareerForm;
